import { useEffect, useState } from 'react'

const Narrow = 825

const getWindowSize = () => {
  return { width: window.innerWidth, height: window.innerHeight }
}

interface LayoutInfo {
  height: number
  width: number
  size: 'large' | 'narrow'
}

export const useLayoutInfo = (): LayoutInfo => {
  const [windowSize, setWindowSize] = useState(getWindowSize())

  const handleResize = () => setWindowSize(getWindowSize())

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  })

  const { width, height } = windowSize

  return {
    width,
    height,
    size: width > Narrow ? 'large' : 'narrow',
  }
}
